import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { Angulartics2Module } from 'angulartics2';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { MobileDeviceWarningDialogue } from 'libs/news-and-support/src/lib/support/mobile-warning/mobile-warning.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NotificationDialoguesService } from './notifications-dialogues.service';
import { WhatsNewDialogue } from './whats-new/whats-new-dialogue.component';

@NgModule({
    imports: [
        CommonModule,
        ModalModule.forChild(),
        LoadingIndicatorModule,
        SharedUiModule,
        AnalyticsModule,
        Angulartics2Module
    ],
    declarations: [WhatsNewDialogue, MobileDeviceWarningDialogue],
    providers: [NotificationDialoguesService]
})
export class NotificationModule {}
